import React, { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import IntroSection from "./components/IntroSection";
import BenefitsSection from "./components/BenefitsSection";
import BackupSection from "./components/BackupSection";
import SpecsSection from "./components/SpecsSection";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";
import PrivacyPolicy from "./components/PrivacyPolicy";
import "./css/index.css";

const everflowProducts = ["Everflow Nano Cube : 150W Portable powerstation", "Everflow Nano : 250W backup solar system","Everflow Nano : 500W backup solar system","Everflow Mini : 800W backup solar system", "1 kw - 6Kw aevolt hybrid systems"];

function App() {
  const [currentHash, setCurrentHash] = useState(window.location.hash);

  useEffect(() => {
    const handleHashChange = () => {
      setCurrentHash(window.location.hash);
      window.scrollTo({ top: 0, behavior: "smooth" });
    };

    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  if (currentHash === "#privacy") {
    return (
      <div>
        <Navbar />
        <PrivacyPolicy />
        <Footer />
      </div>
    );
  }

  return (
    <div>
      <Navbar />
      <Hero />
      <div className="client-marquee" aria-label="Aevolt product range">
        <ul className="client-marquee-track">
          {everflowProducts.map((product) => (
            <li key={product}>{product}</li>
          ))}
        </ul>
        <ul className="client-marquee-track" aria-hidden="true">
          {everflowProducts.map((product) => (
            <li key={`duplicate-${product}`}>{product}</li>
          ))}
        </ul>
      </div>
      <IntroSection />
      <BenefitsSection />
      <BackupSection />
      {/* <AppControlSection /> */}
      <SpecsSection />
      <CTASection products={everflowProducts} />
      <Footer />
    </div>
  );
}

export default App;
